import { render, staticRenderFns } from "./CardTitleContainerNew.vue?vue&type=template&id=58a61ed8&scoped=true"
import script from "./CardTitleContainerNew.vue?vue&type=script&lang=ts"
export * from "./CardTitleContainerNew.vue?vue&type=script&lang=ts"
import style0 from "./CardTitleContainerNew.vue?vue&type=style&index=0&id=58a61ed8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a61ed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a61ed8')) {
      api.createRecord('58a61ed8', component.options)
    } else {
      api.reload('58a61ed8', component.options)
    }
    module.hot.accept("./CardTitleContainerNew.vue?vue&type=template&id=58a61ed8&scoped=true", function () {
      api.rerender('58a61ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardTitleContainerNew.vue"
export default component.exports